import PublicIcon from "@mui/icons-material/Public";

export function TabLabel({ iso, name }) {
  // for real countries
  if (iso !== "total") {
    const code = iso.toLowerCase();
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 4,
        }}
      >
        <span style={{ fontSize: "1.1rem" }}>{name}</span>
        <img
          loading="lazy"
          //   width={32}
          height={18}
          src={`https://flagcdn.com/${code}.svg`}
          alt={`Flag of ${iso}`}
          style={{ borderRadius: 2, transform: "translateY(-3px)" }}
        />
      </div>
    );
  }
  // for the “total” tab
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
      }}
    >
      <span style={{ fontSize: "1.1rem", transform: "translateY(4px)" }}>
        Total
      </span>
      <PublicIcon fontSize="medium" sx={{ transform: "translateY(-2px)" }} />
    </div>
  );
}
